import { render, staticRenderFns } from "./quailty.vue?vue&type=template&id=5b259e60&scoped=true"
import script from "./quailty.js?vue&type=script&lang=js&external"
export * from "./quailty.js?vue&type=script&lang=js&external"
import style0 from "./quailty.vue?vue&type=style&index=0&id=5b259e60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b259e60",
  null
  
)

export default component.exports